import { SET_PRODUCTION_SUMMARY_PROJECTS } from './types';

export const setProductionSummaryProjects = ({ projects = [], cityOptions = [] } = {}) => ({
    type: SET_PRODUCTION_SUMMARY_PROJECTS,
    payload: { projects, cityOptions },
});
